import { post } from '..';

const addAssetNote = (InstanceId: string, Note) => post('assets/notes', {
  InstanceId, Note,
});

export default addAssetNote;
